import styled from 'styled-components';

export const Container = styled.main`
    height: auto;
    padding: 0 137 0 0px;
    display: flex;
    justify-content: space-between;

    content {
      display: flex;
      flex-direction: column;
      width: 100%;
      display: flex;
      align-items: center;
      margin: 50px 0;

      p {
        font-family: Poppins;
        font-size: 15px;
        color: #000;
      }
    }

    section {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;
      align-items: center;

      span {
        font-family: Poppins;
        font-size: 15px;
        color: #000;
        padding: 0;
      }
      
      aside {
        display: flex;
        flex-direction: column;
        width: 100%;
        align-items: center;
      }
    }

  form {
    width: 100%;
    max-width: 670px;
    margin: 25px auto;
    display: flex;
    flex-direction: column;

    div {
      display: flex;
      width: 100%;
      align-items: center;
      flex-direction: column;
    }
    
    input {
      width: 100%;
      display: flex;
      padding: 5px;
      border: 1px solid #c6c6c6;
      color: #000;
      
      :hover {
        border: 1px solid #3FB4A8;
        cursor: pointer;
      }
    }
        
    label {
      display: flex;
      border: 1px solid #3FB4A8;
      width: 100%;
      border-radius: 10px;
    }
  
    button {
      padding: 15px;
      border-radius: 15px;
      margin: 0;
      width: 80%;
      background: #3FB4A8;
      color: #f6f6f6;

      :hover {
        background: #3FB4B8;
      }
    }

    button[id="back"] {
      padding: 15px;
      border-radius: 15px;
      margin: 0;
      width: 80%;
      background: #b6b6b6;
      color: #f6f6f6;

      :hover {
        background: #c6c6c6
      }
    }
  }
`